import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-656e7e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-margin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://zam.care/terms-of-use-mobile-app-blank/",
  target: "_blank"
}, "terms and conditions", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Login")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_ion_header, { collapse: "condense" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_title, { size: "large" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Wie ist dein Name?")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_1, [
              _createTextVNode(" Du hast bereits einen Account? "),
              _hoisted_2,
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoutUser())),
                href: "/"
              }, "Eine andere Nummer versuchen")
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.addName()), ["prevent"]))
            }, [
              _createVNode(_component_ion_input, {
                placeholder: "Vorname",
                modelValue: _ctx.firstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firstName) = $event)),
                class: "ion-margin"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_input, {
                placeholder: "Nachname",
                modelValue: _ctx.lastName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastName) = $event)),
                class: "ion-margin"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_checkbox, {
                    slot: "start",
                    onClick: [
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.terms = !_ctx.terms)),
                      _ctx.tcTimestamp
                    ]
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("I agree to the "),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.formState.type)
              }, _toDisplayString(_ctx.formState.content), 3),
              _createVNode(_component_ion_button, {
                disabled: !_ctx.terms || _ctx.firstName.length < 2 || _ctx.lastName.length < 2,
                type: "submit",
                expand: "block",
                color: "primary",
                class: "ion-margin"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Loslegen ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 32)
          ]),
          _createVNode(_component_ion_loading, {
            "is-open": _ctx.loadingState.formSubmission,
            cssClass: "my-custom-class",
            message: "Please wait..."
          }, null, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}